import React from 'react';
import { Clock3Icon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="bg-[#09281d] px-5 py-16" data-id="element-244" data-mp="2sk41l62s7846">
      <div className="mx-auto max-w-2xl border-2 border-red-400 bg-[#10372a] p-8 text-center sm:p-11" data-id="element-245" data-mp="36ahc9g7250x7">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-red-300" data-id="element-246" data-mp="31ipi6vop0d2b">
          <Clock3Icon className="h-4 w-4" data-id="element-247" data-mp="3g7c6vo07mh67" /> Limited-time offer
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-248" data-mp="3b9apr8mcgrxd">
          The launch price ends in:
        </h2>
        <div className="my-9" data-id="element-249" data-mp="3p80nmqgzmvms">
          <CountdownTimer size="large" dark data-id="element-250" data-mp="3l78d7twdqkox" />
        </div>
        <p className="font-semibold text-white" data-id="element-251" data-mp="3l7q5ygju2gs3">
          After that, the price goes up by $5 and never comes back down.
        </p>
        <div className="mx-auto mt-7 max-w-sm" data-id="element-252" data-mp="1qt748g748hb4">
          <div className="h-3 overflow-hidden border border-red-400/50 bg-[#061b13]" data-id="element-253" data-mp="1quik3edu5fil">
            <div className="h-full w-[72%] bg-red-500" data-id="element-254" data-mp="2sufwygzhputn" />
          </div>
          <div className="mt-3 flex justify-between text-[10px] font-bold uppercase tracking-widest" data-id="element-255" data-mp="2xshozrew94h9">
            <span className="text-red-300" data-id="element-256" data-mp="32s3zvu7928mw">
              Limited spots — offer for today only
            </span>
            <span className="text-slate-300" data-id="element-257" data-mp="37iu6farewhj6">72% claimed</span>
          </div>
        </div>
      </div>
    </section>;
}